var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 562.48 598.15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(-402.97 -612.38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m741.28 683a52.42 52.42 0 0 0 -20.42 4.15 53.28 53.28 0 0 0 -17.31 11.85 54.64 54.64 0 0 0 -11.55 17.67 55.52 55.52 0 0 0 0 41.73 54.79 54.79 0 0 0 11.56 17.69 53.44 53.44 0 0 0 17.31 11.82 52.59 52.59 0 0 0 20.42 4.14z",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "m514.91 1075a52.35 52.35 0 0 0 -20.42 4.15 53.2 53.2 0 0 0 -17.31 11.85 54.65 54.65 0 0 0 -11.57 17.69 55.64 55.64 0 0 0 0 41.73 54.65 54.65 0 0 0 11.57 17.69 53.2 53.2 0 0 0 17.31 11.81 52.35 52.35 0 0 0 20.42 4.15z",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m856.41 1137.49a52.23 52.23 0 0 0 4.17 20.42 53.27 53.27 0 0 0 11.83 17.3 54.7 54.7 0 0 0 17.7 11.55 55.62 55.62 0 0 0 41.72 0 54.75 54.75 0 0 0 17.68-11.58 53.2 53.2 0 0 0 11.8-17.33 52.15 52.15 0 0 0 4.13-20.42z",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m403 1075a57.57 57.57 0 0 1 21.48 4.15 56.27 56.27 0 0 1 18.18 11.85 54.58 54.58 0 0 1 12.16 17.69 53 53 0 0 1 0 41.73 54.58 54.58 0 0 1 -12.16 17.69 56.27 56.27 0 0 1 -18.21 11.81 57.57 57.57 0 0 1 -21.48 4.15z",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "m526.27 612.38a110.71 110.71 0 0 0 8.14 41.72 109.26 109.26 0 0 0 23.2 35.38 107 107 0 0 0 34.71 23.63 105.17 105.17 0 0 0 81.9 0 106.94 106.94 0 0 0 34.72-23.63 109.26 109.26 0 0 0 23.2-35.38 110.71 110.71 0 0 0 8.14-41.72z",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "m964.64 909.84a110.81 110.81 0 0 0 -8.15-41.73 109.11 109.11 0 0 0 -23.2-35.37 106.77 106.77 0 0 0 -34.71-23.64 105.17 105.17 0 0 0 -81.9 0 106.92 106.92 0 0 0 -34.68 23.64 109.24 109.24 0 0 0 -23.19 35.37 110.81 110.81 0 0 0 -8.15 41.73z",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "m745.16 829.86a105.94 105.94 0 0 0 41.06-8.28 107 107 0 0 0 34.78-23.58 108.67 108.67 0 0 0 23.26-35.28 110 110 0 0 0 0-83.22 108.57 108.57 0 0 0 -23.26-35.27 107.22 107.22 0 0 0 -34.81-23.58 106.11 106.11 0 0 0 -41.06-8.27z",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "m635.56 913.25a110.8 110.8 0 0 0 8.15 41.75 109.26 109.26 0 0 0 23.2 35.38 106.9 106.9 0 0 0 34.71 23.62 105.17 105.17 0 0 0 81.9 0 107 107 0 0 0 34.72-23.63 109.23 109.23 0 0 0 23.19-35.37 110.8 110.8 0 0 0 8.15-41.72z",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m516.62 1101.49a110.76 110.76 0 0 0 8.15 41.72 109.26 109.26 0 0 0 23.2 35.38 106.9 106.9 0 0 0 34.71 23.63 105.17 105.17 0 0 0 81.9 0 107 107 0 0 0 34.72-23.63 109.23 109.23 0 0 0 23.19-35.38 110.76 110.76 0 0 0 8.15-41.72z",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m730.64 1097.87a110.81 110.81 0 0 0 -8.15-41.73 109.08 109.08 0 0 0 -23.19-35.37 106.92 106.92 0 0 0 -34.72-23.64 105.17 105.17 0 0 0 -81.9 0 106.77 106.77 0 0 0 -34.68 23.64 109.11 109.11 0 0 0 -23.2 35.37 110.81 110.81 0 0 0 -8.15 41.73z",
    opacity: 0.41
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.52 842.86a84.5 84.5 0 0 0 -32.74 6.6 85.49 85.49 0 0 0 -27.78 18.8 86.77 86.77 0 0 0 -18.55 28.12 87.81 87.81 0 0 0 0 66.36 86.71 86.71 0 0 0 18.55 28.13 85 85 0 0 0 60.49 25.39z",
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m617 838.86a110.71 110.71 0 0 0 -8.14-41.72 109.26 109.26 0 0 0 -23.2-35.38 106.74 106.74 0 0 0 -34.71-23.63 105.17 105.17 0 0 0 -81.9 0 106.78 106.78 0 0 0 -34.72 23.63 109.26 109.26 0 0 0 -23.2 35.38 110.91 110.91 0 0 0 -8.13 41.72z",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m599.67 922.5h-107.3v109a105.81 105.81 0 0 0 41.06-8.3 107.19 107.19 0 0 0 34.81-23.64 109.11 109.11 0 0 0 23.26-35.37 110.64 110.64 0 0 0 8.17-41.69z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m857.4 1025.48-.12 109 107.3.12a110.87 110.87 0 0 0 -8.12-41.74 109.34 109.34 0 0 0 -23.22-35.4 107.35 107.35 0 0 0 -34.79-23.67 105.78 105.78 0 0 0 -41.05-8.31z",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "m634.27 909.84h107.3v-111.1a104 104 0 0 0 -41.06 8.46 107.07 107.07 0 0 0 -34.81 24.08 111.65 111.65 0 0 0 -23.26 36 114.6 114.6 0 0 0 -8.17 42.56z",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "m857.34 721.41h107.3v-109a105.77 105.77 0 0 0 -41.06 8.3 107.21 107.21 0 0 0 -34.81 23.63 109.1 109.1 0 0 0 -23.26 35.38 110.43 110.43 0 0 0 -8.17 41.69z",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "m417.54 1072h54.4v-55.28a53.55 53.55 0 0 0 -20.81 4.21 54.26 54.26 0 0 0 -17.65 12 55.51 55.51 0 0 0 -11.8 17.93 56.17 56.17 0 0 0 -4.14 21.14z",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "m747 1134.58h107.3v-109a105.81 105.81 0 0 0 -41.06 8.3 107.29 107.29 0 0 0 -34.81 23.64 109.27 109.27 0 0 0 -23.26 35.37 110.63 110.63 0 0 0 -8.17 41.69z",
    opacity: 0.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "m462.6 733.57c32.93 0 59.63-27.13 59.63-60.6v-60.59h-119.23v60.62c0 33.44 26.67 60.57 59.6 60.57z",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "m745.68 1165.09a27 27 0 0 0 26.82 27.26h26.83v-54.51h-26.83a27 27 0 0 0 -26.82 27.25z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "m856.28 1165.11a27 27 0 0 0 -26.81-27.27h-26.83v54.52h26.83a27 27 0 0 0 26.81-27.25z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "m842.5 967.76c0 30.11 27.34 54.52 61.07 54.52h61.07v-109h-61.07c-33.73-.03-61.07 24.37-61.07 54.48z",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "m596.32 918.5c20.61 0 37.31-17 37.31-37.91s-16.7-37.91-37.31-37.91-37.3 17-37.3 37.91 16.7 37.91 37.3 37.91z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m647.93 807.24c22.72 0 41.14-18.72 41.14-41.81s-18.42-41.8-41.14-41.8-41.13 18.72-41.13 41.8 18.42 41.81 41.13 41.81z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m618.63 976a21.66 21.66 0 1 0 -21.31-21.66 21.5 21.5 0 0 0 21.31 21.66z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507 1072.94a16.2 16.2 0 1 0 -16-16.2 16.07 16.07 0 0 0 16 16.2z",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    d: "m834 1017.38a15.84 15.84 0 1 0 -15.58-15.84 15.72 15.72 0 0 0 15.58 15.84z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m748.81 1073.85a24.08 24.08 0 1 0 -23.69-24.08 23.88 23.88 0 0 0 23.69 24.08z",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.55 720.25a18.62 18.62 0 1 0 -18.32-18.62 18.47 18.47 0 0 0 18.32 18.62z",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "m516 889a24 24 0 1 0 -23.59-24 23.78 23.78 0 0 0 23.59 24z",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "m536.55 918.5a13.84 13.84 0 1 0 -13.62-13.83 13.72 13.72 0 0 0 13.62 13.83z",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "m854.34 668.9a23.11 23.11 0 1 0 -22.73-23.11 22.93 22.93 0 0 0 22.73 23.11z",
    opacity: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    d: "m921 812.27c23.54 0 42.63-19.39 42.63-43.32s-19.08-43.32-42.63-43.32-42.62 19.37-42.62 43.37 19.08 43.27 42.62 43.27z",
    opacity: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInn);
export default __webpack_public_path__ + "static/media/inn.9b0755622b13e0355b9bbb1d44dae74a.svg";
export { ForwardRef as ReactComponent };